import Main from '../Main/Main.js';
import Footer from '../Footer/Footer.js'

const Website = () => {

    return (
        <div>
            <Main />
            <Footer />
        </div>
    );
}

export default Website;
